"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefiPassportStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var DefiPassportStorageFactory = /** @class */ (function (_super) {
    __extends(DefiPassportStorageFactory, _super);
    function DefiPassportStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    DefiPassportStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    DefiPassportStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    DefiPassportStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DefiPassportStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DefiPassportStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return DefiPassportStorageFactory;
}(contracts_1.ContractFactory));
exports.DefiPassportStorageFactory = DefiPassportStorageFactory;
var _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "approvedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "defaultActiveSkin",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "skinTokenId",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "defaultSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "skinManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=DefiPassportStorageFactory.js.map